import { Navigate, Route, Routes } from "react-router-dom";
import { lazy, Suspense, useState } from "react";

import PageHomeOut from "../../pages/out/PageHomeOut";
import useConcurrentTransition from "../../hooks/useConcurrentTransition";

const LazyPageLogin = lazy(() => import("../../pages/out/PageLogIn"));
const LazyPageRegister = lazy(() => import("../../pages/out/PageRegister"));
const LazyPagePreRegister = lazy(() => import("../../pages/out/PagePreRegister"));
const LazyPageRegisterInactive = lazy(() => import("../../pages/out/PageRegisterInactive"));
const LazyPagePassword = lazy(() => import("../../pages/out/PagePassword"));
const LazyPagePasswordCode = lazy(() => import("../../pages/out/PagePasswordCode"));
const LazyPagePasswordReset = lazy(() => import("../../pages/out/PagePasswordReset"));
const LazyPagePasswordSuccess = lazy(() => import("../../pages/out/PagePasswordSuccess"));
const LazyPageFaq = lazy(() => import("../../pages/out/PageFaq"));
const LazyPageDisclaimer = lazy(() => import("../../pages/out/PageAuthorization"));
const LazyPageActualizarClave = lazy(() => import("../../pages/out/PageActualizarClave"));

export default function RouterOut() {
    const [defaultInRoute] = useState("/inicio-sesion");
    const location = useConcurrentTransition();

    return (
        <Suspense fallback={<div className="min-h-[80vh]"></div>}>
            <Routes location={location}>
                <Route path="/" element={<PageHomeOut />} />
                <Route path="/inicio-sesion" element={<LazyPageLogin />} />
                <Route path="/registrate" element={<LazyPageRegister />} />
                <Route path="/registrate/registro-usuario-no-activo" element={<LazyPageRegisterInactive />} />
                <Route path="/registro" element={<LazyPagePreRegister />} />
                <Route path="/registrate/paso2" element={<LazyPageRegister />} />
                <Route path="/tyc-beneficiarios/:str" element={<LazyPageDisclaimer />} />
                <Route path="/autorizacion-menores/:str" element={<LazyPageDisclaimer />} />
                <Route path="/olvidaste-tu-contrasena/" element={<LazyPagePassword />} />
                <Route path="/olvidaste-tu-contrasena/codigo" element={<LazyPagePasswordCode />} />
                <Route path="/olvidaste-tu-contrasena/restablecer" element={<LazyPagePasswordReset />} />
                <Route path="/olvidaste-tu-contrasena/exito" element={<LazyPagePasswordSuccess />} />
                <Route path="/actualizar-clave" element={<LazyPageActualizarClave />} />
                <Route path="/preguntas-frecuentes" element={<LazyPageFaq />} />
                <Route path="/*" element={<Navigate to={defaultInRoute} />} />
            </Routes>
        </Suspense>
    );
}
